// @flow
import Box from "@mui/material/Box";
import React, { useState } from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import PasswordCloseIcon from "../../../assets/images/icons/login/passwordCloseIcon";
import PasswordOpenIcon from "../../../assets/images/icons/login/passwordOpenIcon";
import { textFieldDefaults } from "../../../helpers/theme/defaultProps";

type Props = {
	name: string,
	required?: boolean,
	value: string,
	onChange: Function,
	onBlur?: Function,
	allowBrowserAutocomplete?: boolean,
	otherProps?: Object
};

const PasswordInput = (props: Props) => {
	const {
		name,
		required = false,
		value,
		onChange = () => {
		},
		onBlur = () => {
		},
		allowBrowserAutocomplete,
		...otherProps
	} = props
	
	const [showPassword, setShowPassword] = useState(false);
	const handleClickShowPassword = () => setShowPassword((show) => !show);
	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};
	
	return (
		<TextField
			{...textFieldDefaults}
			name={name}
			required={required}
			type={showPassword ? 'text' : 'password'}
			value={value}
			onChange={onChange}
			onBlur={onBlur}
			sx={{
				'& .MuiOutlinedInput-root': {
					':focus-within': { border: '0.0px solid #ffffff !important' }
				},
			}}
			slotProps={{
				input: {
					endAdornment: (
						<InputAdornment position="end">
							<Box
								aria-label="toggle password visibility"
								onClick={handleClickShowPassword}
								onMouseDown={handleMouseDownPassword}
								edge="end"
								sx={{
									cursor: 'pointer'
								}}
							>
								{showPassword ? <PasswordCloseIcon/> : <PasswordOpenIcon/>}
							</Box>
						</InputAdornment>
					)
				},
				htmlInput: {
					maxLength: '100',
					autoComplete: allowBrowserAutocomplete ? 'current-password' : 'new-password',
				}
			}}
			{...otherProps}
		/>
	);
};

export default PasswordInput